import { Menu } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MENU_ITEMS } from "../../consts";

const AppMenu = () => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    function setSelect() {
      setSelectedKeys([location.pathname]);
    }
    setSelect();
  });

  const handleSelect = (event) => {
    setSelectedKeys(event.selectedKeys);
    navigate(event.key);
  };
  return (
    <Menu
      onSelect={handleSelect}
      theme="dark"
      mode="horizontal"
      selectedKeys={selectedKeys}
      items={MENU_ITEMS}
    />
  );
};

export default AppMenu;
